import { localePort } from '@/app/locale'
import { useLocaleMessages as useCatalogMessages } from '@/shared/i18n'
import type { LocaleCatalog, LocaleMessageTree } from '@/shared/i18n'
import type { ComputedRef } from 'vue'

export function useI18n(): typeof localePort {
  return localePort
}

export function useLocaleMessages<T extends LocaleMessageTree>(
  catalog: LocaleCatalog<T>,
): ComputedRef<LocaleCatalog<T>[keyof LocaleCatalog<T>]> {
  return useCatalogMessages(catalog, localePort.locale)
}
